module.exports = __webpack_public_path__ + "fonts/icofont.b836475e.eot";